import { useTypedSelector } from "../hooks";
import { CampaignInfo } from "../slices/campaignSlice";

export const useNullableCampaignInfo = (): CampaignInfo | null => {
  const campaignInfo = useTypedSelector((state) => state._campaignInfo);
  return campaignInfo;
};
